<template>
  <div class="info-place pl-4 pr-4">
    <div>
      <div class="w-full">
        <SmartInput
          label="Nome do Produto"
          placeholder="Ex: Campanha"
          v-model="productName"
          name="name"
          :error="errors.first('name')"
          v-validate="'required'"
          :key="resetField"
        />
        <div class="mt-4" v-if="additionalGoal === null">
          <span>Referenciar outro produto?</span>
          <v-radio-group
            @change="resetSelect"
            class="mt-4"
            v-model="optionSelected"
            :row="true"
          >
            <v-radio
              v-for="option in options"
              :key="option.id"
              :label="option.label"
              :value="option.id"
              :max="1"
            />
          </v-radio-group>
          <VSelect
            v-if="optionSelected === 1 || additionalGoal !== null"
            class="mt-4"
            v-model="selectedOption"
            :items="segments"
            item-text="name"
            item-value="id"
            placeholder="Informe o nome do produto"
            label="Nome do Produto Referenciado"
          >
            <template v-slot:item="{ item, index }">
              <div class="v-list__tile__content">
                <div :id="`segments-${index}`" class="v-list__tile__title">
                  {{ item.name }}
                </div>
              </div>
            </template>
          </VSelect>
          <VSelect
            v-if="optionSelected === 1 || additionalGoal !== null"
            class="mt-4"
            v-model="selectedType"
            :items="types"
            item-text="goal_dimension_indicator"
            item-value="id"
            placeholder="Selecione o tipo"
            label="Tipo"
          >
            <template v-slot:item="{ item, index }">
              <div class="v-list__tile__content">
                <div :id="`segments-${index}`" class="v-list__tile__title">
                  {{ item.goal_dimension_indicator }}
                </div>
              </div>
            </template>
          </VSelect>
        </div>
        <div v-if="optionSelected === 2 && additionalGoal === null">
          <h4 style="font-weight: 500">Importar Arquivo</h4>
          <br />
          <span
            style="
              font-weight: 500;
              color: #82c85a;
              text-decoration: underline;
              cursor: pointer;
            "
            @click="downloadModelView"
            >baixar modelo</span
          >
          <br />
          <br />
          <div class="flex justify-start">
            <input
              style="display: none"
              type="file"
              :key="fileUploadKey"
              id="fileInput"
              @change="importGoalView"
              class="fileInput"
            />
            <label
              class="
                btn-import-load-goal-view
                cursor-pointer
                rounded
                h-5
                px-3
                text-center
                mt-1
                ml-2
              "
              for="fileInput"
            >
              <SmartIcon name="download" :size="1" />&nbsp;&nbsp;
              <span>Carga Meta PDV</span>
            </label>
          </div>
        </div>
        <div
          class="w-full"
          v-if="optionSelected === 1 || additionalGoal !== null"
        >
          <SmartCard class="flex card w-full justify-around mt-4 align-center">
            <div>
              <span>Produto/Regional</span>
            </div>
            <div class="mr-4">
              <span>Volume</span>
            </div>
            <div>
              <span>Faturamento</span>
            </div>
          </SmartCard>
        </div>
        <SmartCard
          v-show="optionSelected === 1 || additionalGoal !== null"
          class="
            flex
            w-full
            mt-1
            inputcard
            justify-center justify-around
            adjustments-smartcard
          "
          v-for="(view, index) in views"
          :key="view.id"
        >
          <div class="inputClass">
            <span class="text-center absolute mt-3 ml-5 text-black">{{
              view.name
            }}</span>
          </div>
          <template v-if="additionalGoalViews[index]">
            <div class="inputClass">
              <SmartInputMoney
                type="volume"
                class="input"
                v-model="additionalGoalViews[index].volume"
              />
            </div>
            <div class="inputClass" v-if="additionalGoalViews[index]">
              <SmartInputMoney
                type="money"
                class="input"
                v-model="additionalGoalViews[index].billing"
              />
            </div>
          </template>
        </SmartCard>
        <div class="flex justify-end mt-4">
          <SmartButton
            v-show="optionSelected === 1"
            v-if="additionalGoal === null"
            :loading="isLoading"
            :disabled="!formIsValid"
            @click="sendInfo"
          >
            Salvar
          </SmartButton>
          <SmartButton
            v-else
            :loading="isLoading"
            :disabled="!formIsValid"
            @click="editInfo"
          >
            Editar
          </SmartButton>
        </div>
      </div>
      <div>
        <SmartModal
          v-if="modal"
          v-bind="modal"
          @close.prevent="close"
          @return="close"
        >
          {{ modal.text }}
        </SmartModal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { downloadCsvFile } from "utils/blob";

export default {
  name: "infoAdditional",
  props: ["additionalGoal"],
  data() {
    return {
      isLoading: false,
      productName: "",
      selectedType: "",
      options: [
        { id: 1, label: "Sim" },
        { id: 2, label: "Não" },
      ],
      optionSelected: 1,
      selectedOption: null,
      additionalGoalViews: [],
      modal: null,
      isLoadingImport: false,
      fileUploadKey: 0,
      resetField: 0,
    };
  },
  computed: {
    ...mapGetters({
      list: "additionalGoals/list",
      views: "additionalGoals/views",
      segments: "additionalGoals/segments",
      types: "additionalGoals/types",
    }),
    formIsValid() {
      return Object.keys(this.fields).every(this.isValidAndRequired);
    },
  },
  methods: {
    ...mapActions({
      fetchList: "additionalGoals/fetchList",
      fetchViews: "additionalGoals/fetchViews",
      fetchSegments: "additionalGoals/fetchSegments",
      sendAdditionalGoal: "additionalGoals/sendAdditionalGoal",
      fetchAdditionalGoals: "additionalGoals/fetchAdditionalGoals",
      fetchTypes: "additionalGoals/fetchTypes",
      importCsvFile: "additionalGoals/importFileGoalView",
      getExample: "additionalGoals/getExample",
      editGoalAction: "additionalGoals/editGoalAction",
    }),

    downloadModelView() {
      const currentDate = moment().format("Do_MM_YYYY, h:mm:ss a");
      this.isLoadingExport = true;
      this.getExample()
        .then((response) => {
          this.isLoadingExport = false;
          downloadCsvFile({
            filename: `carga_metas_adicionais_${currentDate}`,
            file: response.data,
          });
        })
        .catch(({ data }) => {
          this.showModal({
            type: "warning",
            title: "Ops! Algo de errado...",
            icon: "alert",
            buttonText: "Ok",
            text: data.message ? data.message : "Erro desconhecido",
          });
        })
        .finally(() => {
          this.isLoadingExport = false;
        });
    },

    downloadModelPDV() {
      const currentDate = moment().format("Do_MM_YYYY, h:mm:ss a");
      this.isLoadingExport = true;
      this.getExamplePDV()
        .then((response) => {
          this.isLoadingExport = false;
          downloadCsvFile({
            filename: `carga_metas_adicionais_${currentDate}`,
            file: response.data,
          });
        })
        .catch(({ data }) => {
          this.showModal({
            type: "warning",
            title: "Ops! Algo de errado...",
            icon: "alert",
            buttonText: "Ok",
            text: data.message ? data.message : "Erro desconhecido",
          });
        })
        .finally(() => {
          this.isLoadingExport = false;
        });
    },

    importGoalView(event) {
      this.isLoadingImport = true;
      const file = event.target.files[0];
      const formData = new FormData();
      formData.set("file", file, file.name);
      this.importCsvFile(formData)
        .then(() => {
          this.modal = {
            type: "success",
            title: "Ok, tudo certo!",
            icon: "accepted",
            buttonText: "Ok",
            text: "O arquivo foi importado.",
          };
        })
        .catch((error) => {
          this.modal = {
            type: "warning",
            title: "Arquivo não importado.",
            icon: "warning",
            buttonText: "Ok",
            text: error.data.message,
          };
        })
        .finally(() => {
          this.isLoadingImport = false;
        });
      this.fileUploadKey++;
    },

    isValidAndRequired(field) {
      return this.fields[field].required ? this.fields[field].valid : true;
    },
    clearAllFields() {
      this.productName = "";
      this.additionalGoalViews = [];
      this.selectedOption = null;
    },
    resetSelect() {
      this.selectedOption = null;
    },
    sendInfo() {
      const payload = {
        name: this.productName,
        segment_id: this.selectedOption,
        goals_type_id: this.selectedType,
        additional_goal_views: this.additionalGoalViews.map((item) => ({
          billing:
            item.billing.toString().replace(/\./g, "").replace(/\,/g, ".") || 0,
          volume:
            item.volume.toString().replace(/\./g, "").replace(/\,/g, ".") || 0,
          view_id: item.view_id,
        })),
      };
      this.isLoading = true;
      this.sendAdditionalGoal({ payload })
        .then(() => {
          this.clearAllFields();
          this.showSuccessModal();
          this.fetchAdditionalGoals();
        })
        .catch((e) => {
          this.showErrorModal(e);
        })
        .finally(() => {
          this.isLoading = false;
          this.resetInputsWhenModalCloses();
        });
    },
    editInfo() {
      const payload = {
        id: this.additionalGoal.id,
        name: this.productName,
        segment_id: this.selectedOption,
        goals_type_id: this.selectedType,
        additional_goal_views: this.additionalGoalViews.map((item) => ({
          billing:
            item.billing.toString().replace(/\./g, "").replace(/\,/g, ".") || 0,
          volume:
            item.volume.toString().replace(/\./g, "").replace(/\,/g, ".") || 0,
          view_id: item.view_id,
        })),
      };
      this.isLoading = true;
      this.editGoalAction({ payload })
        .then(() => {
          this.clearAllFields();
          this.showSuccessModal();
          this.fetchAdditionalGoals();
        })
        .catch((e) => {
          this.showErrorModal(e);
        })
        .finally(() => {
          this.isLoading = false;
          this.resetInputsWhenModalCloses();
        });
    },
    close() {
      this.$emit("close");
      this.modal = null;
      this.resetInputsWhenModalCloses();
    },
    async resetInputsWhenModalCloses() {
      this.productName = "";
      this.optionSelected = 2;
      this.selectedOption = null;
      this.additionalGoalViews = this.views.map((view) => ({
        view_id: view.id,
        billing: 0,
        volume: 0,
      }));
      await this.$nextTick();
      this.errors.clear();
    },
    showSuccessModal() {
      this.modal = {
        type: "success",
        title: "Tudo Certo!",
        icon: "accepted",
        buttonText: "Ok",
        text: "Meta adicional criada com sucesso!",
      };
    },
    showErrorModal(response) {
      const message =
        typeof response.data.error === "undefined"
          ? `${response.data.help}\n${response.data.message}`
          : `${response.data.error.help}\n${response.data.error.message}`;

      this.modal = {
        type: "warning",
        title: "Ops! Algo deu errado...",
        icon: "alert",
        buttonText: "Ok",
        text: message,
      };
    },
    addInfoInitial() {
      if (this.additionalGoal === null) {
        this.productName = "";
        this.resetField++;
        this.additionalGoalViews = this.views.map((view) => ({
          view_id: view.id,
          billing: 0,
          volume: 0,
        }));
      } else {
        this.productName = this.additionalGoal.name;
        this.additionalGoalViews = this.views.map((view, index) => ({
          view_id: view.id,
          billing: this.additionalGoal.views[index + 1].faturamento,
          volume: this.additionalGoal.views[index + 1].volume,
        }));
      }
    },
  },
  watch: {
    additionalGoal() {
      this.addInfoInitial();
    },
  },
  async mounted() {
    this.fetchSegments();
    this.fetchTypes();
    await this.fetchViews();
    this.addInfoInitial();
  },
};
</script>

<style scoped lang="scss">
.adjustments-smartcard {
  padding: 10px;
}

.inputClass {
  width: 105px;
}
.inputClass:nth-child(even) {
  background: rgba(151, 151, 151, 0.05);
}
.inputcard:nth-child(even) {
  background: rgba(151, 151, 151, 0.05);
}
.card {
  background: rgba(151, 151, 151, 0.05);
}

.input {
  background: white;
}

.btn-import-load-goal-view {
  width: 200px !important;
  background-color: rgba(119, 189, 79, 0.12) !important;
  color: #77bd4f !important;
  margin: 0 1rem 0 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none !important;
  &:hover {
    background-color: #deefd5 !important;
    color: #77bd4f;
  }
}

.models-links a {
  color: #77bd4f !important;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: gray !important;
  }
}
</style>
